import React, { useState, useEffect, useRef } from "react";
import { X } from "lucide-react";

const DELETE_PASSWORD = "2528";

export default function DeleteConfirmModal({ visible, message, onConfirm, onCancel, title, confirmLabel, confirmStyle }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (visible) {
      setPassword("");
      setError("");
      setLoading(false);
      setTimeout(() => inputRef.current?.focus(), 80);
    }
  }, [visible]);

  if (!visible) return null;

  async function handleConfirm() {
    if (password !== DELETE_PASSWORD) {
      setError("Contraseña incorrecta");
      setPassword("");
      inputRef.current?.focus();
      return;
    }
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") handleConfirm();
    if (e.key === "Escape") onCancel();
  }

  return (
    <div style={s.overlay} onClick={onCancel}>
      <div style={s.box} onClick={(e) => e.stopPropagation()}>
        <div style={s.header}>
          <span style={s.title}>{title || "Confirmar eliminación"}</span>
          <button style={s.closeBtn} onClick={onCancel}>
            <X size={16} />
          </button>
        </div>

        <p style={s.message}>{message}</p>

        <label style={s.label}>Contraseña de administrador</label>
        <input
          ref={inputRef}
          type="password"
          style={s.input}
          value={password}
          onChange={(e) => { setPassword(e.target.value); setError(""); }}
          onKeyDown={handleKeyDown}
          placeholder="••••"
          autoComplete="off"
        />
        {error && <p style={s.error}>{error}</p>}

        <div style={s.actions}>
          <button style={s.btnCancel} onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button style={{ ...s.btnDelete, ...confirmStyle }} onClick={handleConfirm} disabled={loading}>
            {loading ? "…" : (confirmLabel || "Eliminar")}
          </button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 9000, padding: 24,
  },
  box: {
    background: "var(--bg-card)", borderRadius: 16, padding: 28,
    width: "100%", maxWidth: 400,
    boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
    border: "1px solid var(--border)",
  },
  header: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    marginBottom: 16,
  },
  title: { fontSize: 17, fontWeight: 700, color: "var(--text)" },
  closeBtn: {
    background: "none", border: "none", cursor: "pointer",
    color: "var(--text-3)", display: "flex", padding: 4,
  },
  message: { fontSize: 14, color: "var(--text-2)", marginBottom: 20, lineHeight: 1.5 },
  label: {
    display: "block", fontSize: 12, fontWeight: 700, color: "var(--text-2)",
    marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.04em",
  },
  input: {
    width: "100%", padding: "10px 12px", borderRadius: 8,
    border: "1px solid var(--border)", fontSize: 18, letterSpacing: 6,
    boxSizing: "border-box", outline: "none", fontFamily: "Montserrat, sans-serif",
    marginBottom: 6, background: "var(--bg-card)", color: "var(--text)",
  },
  error: { color: "var(--error-text)", fontSize: 13, margin: "0 0 12px" },
  actions: { display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 20 },
  btnCancel: {
    padding: "10px 18px", borderRadius: 8,
    border: "1px solid var(--border)", background: "var(--bg-card)",
    color: "var(--text-2)", fontWeight: 700, cursor: "pointer",
    fontSize: 14, fontFamily: "Montserrat, sans-serif",
  },
  btnDelete: {
    padding: "10px 20px", borderRadius: 8, border: "none",
    background: "#dc2626", color: "#fff",
    fontWeight: 700, cursor: "pointer",
    fontSize: 14, fontFamily: "Montserrat, sans-serif",
  },
};
